// extracted by mini-css-extract-plugin
export var category = "_j5-9";
export var categoryHeader = "_j5-e";
export var container = "_j5-0";
export var group = "_j5-a";
export var groupItems = "_j5-f";
export var groupSeparator = "_j5-j";
export var loading = "_j5-1";
export var noResults = "_j5-3";
export var placeholder = "_j5-2";
export var resultContent = "_j5-5";
export var resultIcon = "_j5-c";
export var resultItem = "_j5-g";
export var resultMeta = "_j5-8";
export var resultSubtitle = "_j5-7";
export var resultSuffix = "_j5-i";
export var resultTitle = "_j5-6";
export var resultsList = "_j5-4";
export var searchGroup = "_j5-d";
export var selected = "_j5-h";
export var subgroup = "_j5-b";